<div class="master-overview-container">
  <div class="master-container">
    <div class="master-side-bar-container">
      <h4 class="page-heading"><span>Masters</span> <button class="add-master" matTooltip="Create Master" (click)="createMaster()">+</button></h4>
      <app-master-list (masterSelected)="onMasterSelected($event)" (masterDataList)="getMasterDataList($event)" (updateMaster)="editMaster($event)"></app-master-list>
    </div>
    <div class="master-value-container">
      <div class="header-action-container d-flex justify-content-between">
        <h5 class="m-0"> {{selectedMasterName}}</h5>
        <div class="d-flex justify-content-between actions">
          <div class="search">
           <input class="search-input" [formControl]="searchField" type="text" name="search"
          placeholder="Search Master Value Name, Label, or ID...">
          </div>
                <div class="custom-control status-change">
            <mat-form-field class="" appearance="outline" floatLabel="always">
              <mat-label>Status</mat-label>
                                <mat-select  [(value)]="selectedStatus" (selectionChange)="selectedUpdateStatus($event.value)" placeholder="Status" >
                                    <mat-option *ngFor="let list of status_list" [value]="list.value">
                                        {{ list.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
      </div>
        <app-gis-primary-button
        button_label="Add Master Value"
        [class]="'gis-primary-button'"
        (click)="createMasterValue()"
        [isDisabled]="!masterDataList?.length"
        >
      </app-gis-primary-button>
         <!-- Language -->

          <button [disabled]="!selectedRows?.length" class="copy-btn" type="button" (click)="copyMasterValues()">
        <img src="../../../assets/icon/copy-two-paper-sheets-interface-symbol.png" alt="">
      </button>
        </div>
      </div>

      <div class="data-table">
        <!-- Data table component -->
        <app-gis-data-table
         (selectedRowsChange)="onSelectedRowsChange($event)"
         (pageChange)="onPageChange($event)"
          [buttons]="buttonConfig"
          [data]="masterValueOptions"
           [columns]="displayColumn"
          [totalCount]="totalCount"
          (sortChange)="onSort($event)"
         (resetSortingEvent)="resetSorting()"
         [isSorting]="true"
         (toggleStatus)="updateMasterValueStatus($event)">
        </app-gis-data-table>
      </div>
    </div>
  </div>
</div>
<!-- Loading indicator -->
  <ngx-loading
    [show]="isLoading"
    [config]="{ backdropBackgroundColour: 'rgba(255,255,255,0.3)' }"
  ></ngx-loading>
